// src/components/BookingStatusBadge.jsx
import { Badge } from "@chakra-ui/react";

export default function BookingStatusBadge({ status }) {
  const s = (status || "").toLowerCase();

  let color = "gray";
  if (s === "booked") color = "green";
  else if (s === "pending") color = "yellow";
  else if (s === "cancelled") color = "red";

  return (
    <Badge colorScheme={color} textTransform="capitalize">
      {status || "unknown"}
    </Badge>
  );
}
